import { api } from '@/shared/api';
import { API_ENDPOINTS } from '@/constants/api';
import { normalizePaginatedResponse } from '@/shared/api/pagination';
import type { PaginatedApiResponse } from '@/shared/api/pagination';
import type { PaginatedResponse } from '@/shared/types/entity';
import type { TrialFunnelError } from '../types';

export const trialFunnelErrorsApi = {
  getList: async (params?: {
    page?: number;
    perPage?: number;
    search?: string;
    dateFrom?: string;
    dateTo?: string;
  }): Promise<PaginatedResponse<TrialFunnelError>> => {
    const response = await api.get<PaginatedApiResponse<TrialFunnelError>>(
      API_ENDPOINTS.TRIAL_FUNNEL_ERRORS.LIST,
      { params },
    );
    return normalizePaginatedResponse(response.data);
  },
};
